import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import queryString from 'query-string';
import { appService } from '../../_services';
import { FaWindows } from 'react-icons/fa';
import { Maintenance } from '../Maintenance/Maintenance.jsx';

let RedirectURL = '', url = '', params = '';

export class UrlDocRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = { IsError: false }
    }

    async renderRedirect() {
        var self = this;
        var code = '';
        var area = '';
        var values = '';

        url = this.props.location.search;
        params = queryString.parse(url);

        if (params.requested) {
            code = params.requested.split("id=").pop();
        }
        else if (params.id) {
            code = params.id;
        }
        else if (params.pubcode) {
            code = params.pubcode;
        }
        if (params.area) {
            area = params.area;
        }
        if (params.values) {
            values = params.values;
        }
        if (code != "") {
            await appService.getById('Product/GetURLParameters?code=', code)
                .then(function (data) {
                    if (data.isErrorExist == true) {
                        self.setState({ IsError: true });
                        const metaRobots = document.createElement('meta');
                        metaRobots.name = 'robots';
                        metaRobots.content = 'noindex';
                        document.head.appendChild(metaRobots);
                    }
                    else {
                        self.RedirectURL = '';
                        if (data.productTypeId == 1 && data.prodDetailId > 0) {
                            RedirectURL = "api/Product/CitationPDFURL?file=Journals//" + data.code + "//" + data.fileName;
                        }
                        else if (data.productTypeId == 2 && data.prodDetailId > 0) {
                            RedirectURL = "api/Product/CitationPDFURL?file=Manuals//" + data.code + "//" + data.fileName;
                        }
                        else if (data.productTypeId == 3 && data.prodDetailId > 0) {
                            RedirectURL = "api/Product/CitationPDFURL?file=Encyclopedias//" + data.code + "//" + data.fileName;
                        }
                    }
                });
        }
        if (RedirectURL != '') {
            window.location.href = RedirectURL;
        }
    }
    render() {
        if (this.state.IsError != true) {
            this.renderRedirect()
        }
        return (
            this.state.IsError != true ?
                <div></div>
                :
                <Maintenance />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/UrlDocRedirect.jsx